export default __webpack_public_path__ + "static/media/06.08bac546.jpg";